import { styled } from '@nykaa/ui-components';

// components
import RippleIt from 'shared/components/RippleIt';

import { truncate } from 'shared/styles/mixin/core';

export const ActionButton = styled(RippleIt)`
  display: flex;
  width: auto;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;


export const SearchContainer = styled(ActionButton)`
  position: static;
  min-width: 64px;
  height: 40px;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: space-between;
  flex: 1 1 0;
  overflow: hidden;
  ${({ theme }) => `
    border: 1px solid ${theme.colors.textOutline};
    padding: ${theme.spacing.spacing40} ${theme.spacing.spacing60};
    border-radius: ${theme.borders.radius50};
    margin-left: ${theme.spacing.spacing80};
  `};
`;

export const SearchButton = styled.div`
line-height: 0;
  svg {
      fill: ${({ theme }) => theme.colors.textPrimary};
    }
`;

const SearchPlaceHolder = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  vertical-align: middle;
  ${truncate}
`;
export const PlaceHolderContainer = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  flex: 1 1 0;
  width: 0;
`;
export const PlaceHolder1 = styled(SearchPlaceHolder)`
  color: ${({ theme }) => theme.colors.surfaceInverse10};
  margin-right: ${({ theme }) => theme.spacing.spacing20};
  flex-shrink: 1;
  min-width: 0;
`;

export const PlaceHolder2 = styled(SearchPlaceHolder)`
  color: ${({ theme }) => theme.colors.textPrimary};
  flex: 1 1 0;
`;